import React from 'react';
import Language from '../../language';

export default class HeaderPanelTop extends React.Component {
  static propTypes = {
    panels:   React.PropTypes.object.isRequired,
    language: React.PropTypes.object
  };

  render () {
    var content = null;

    switch (this.props.panels.top) {
      case 'language':
        content = <Language {...this.props.language} />;
        break;
      default:
        return false;
    }

    return (
      <div className="header__panel--top">
        {content}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/header/panels/top/index.js